<h1 class="d-none">Kachiing News</h1>
<div class="news-hero">
  <div class="container" style="position: relative;">
    <div class="back-button-section">
      <button class="back-button" (click)="goBack()"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back</button>
    </div>
    <img loading="lazy" class="my-banner" src="../../../../assets/images/new/news.jpeg" alt="" />
    <div class="news-hero__card">
      <div class="news-hero__card--title">WRITE ARTICLES TO EDUCATE AND ENCOURAGE THE COMMUNITY</div>
      <!-- [class.open]="cardDesc" -->
      <div class="news-hero__card--desc">Join our community and earn extra income by writing articles. Whether you are a
        professional or a beginner, you can turn your words into encouragement by sharing your thoughts and writing
        about topics that interest you. Start now and enjoy generous financial rewards!</div>
      <button class="button-3 white" *ngIf="roleService?.roles?.userType?.includes('ADMIN')"
        (click)="openModalBlogForm()">New Post</button>
      <button class="button-3" (click)="openBulletinModal()">Suggest Topic</button>
      <!-- <button class="button-3" routerLink="/bulletin">Bulletin</button> -->
      <!-- <button class="button-3" (click)="cardDesc = !cardDesc">
        <i class="fas fa-chevron-down"></i>
      </button> -->
    </div>
  </div>
</div>
<div class="container">
  <section class="my-news {{ shop_template }} {{ isMarketplace ? 'marketplace-container' : '' }}">
    <div class="header">
      <div class="left">
        <div>
          <app-breadcrumb [data]="[
            {
              name: 'News',
              link: '/news',
              active: true
            }
          ]"></app-breadcrumb>
        </div>
        <!-- <div class="back" (click)="goBack()">
          <i class="fa fa-caret-left back-btn"></i>
          Back
        </div> -->
        <div class="d-flex align-center">
          <div class="group-btn">
            <button (click)="isPopular = false; getNewsList()" class="my-btn"
              [class.active]="!isPopular">Latest</button>
            <button (click)="isPopular = true; getNewsList()" class="my-btn" [class.active]="isPopular">Popular</button>
          </div>
        </div>
      </div>
      <div class="right">
        <h2 class="d-none">News Category</h2>
        <app-my-carousel-swiper class="my-carousel-width-auto" [config]="carouselOptions">
          <div class="swiper-slide" *ngFor="let row of categories">
            <p class="d-none">{{ row }}</p>
            <div (click)="filterByCategory(row)" class="item" [class.active]="row == category">
              <i class="fa-solid fa-{{ categoryIconMap[row] }}"></i>
              <div class="text">{{ row }}</div>
            </div>
          </div>
        </app-my-carousel-swiper>
      </div>

      <!-- <span class="my-auto fw-bolder" style="font-weight: 600; font-size: 1.3em;">Popular</span> -->
      <!-- <div class="d-flex ml-1" *ngIf="isPopular">
            <button class="btn btn-light rounded-0 rounded-left" (click)="prev()"><i
                class="fa-solid fa-chevron-left" style="cursor: pointer;"></i></button>
            <button class="btn btn-light rounded-0 rounded-right" (click)="next()"><i
                class="fa-solid fa-chevron-right" style="cursor: pointer;"></i></button>
          </div> -->
    </div>

    <div class="row">
      <div class="col-lg-9">
        <div class="mt-2">
          <div *ngIf="banners.data?.length == 0" class="alert alert-secondary text-center" role="alert">
            <i class="fa-regular fa-comment-alt"></i> There are no
            {{ category }}
            posted at this time
          </div>
          @if(category == 'Promotions') {
          <div class="grid-promotions">
            <ng-container *ngFor="let i of banners.data; let index = index">
              <div class="my-card">
                <img loading="lazy" [routerLink]="'/news/' + (i.slug ?? i.id)" [src]="imgUrl + i.image" alt="..."
                  (error)="commonService.handleError($event)" />
                <div class="body">
                  <div class="body--meta">
                    {{ i.category }}
                    <div class="options">
                      <div class="icon" aria-hidden="true" id="list-new" *ngIf="isLogin" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-ellipsis-v"></i>
                      </div>
                      <div class="dropdown-menu" aria-labelledby="list-new">
                        <a *ngIf="roleService.roles?.permissions['NEWS_ARTICLE']?.includes('ADD')" class="dropdown-item"
                          (click)="openModalRelate(i)">Add Relate Article</a>
                        <a *ngIf="roleService.roles?.permissions['NEWS_ARTICLE']?.includes('REMOVE') && i?.related?.length > 0"
                          class="dropdown-item" (click)="openModalRelate(i,true)">Remove Relate
                          Article</a>
                        <a class="dropdown-item" (click)="addDiamonds(AddDiamonds, i)">Add Diamonds</a>
                        <a class="dropdown-item"
                          *ngIf="this.appUserId == i.createdBy || roleService?.roles?.users?.includes('MEMBER_NEWS')"
                          (click)="editBlog(i)">Edit</a>
                        <a class="dropdown-item"
                          *ngIf="this.appUserId == i.createdBy || roleService?.roles?.users?.includes('MEMBER_NEWS')"
                          (click)="deleteBlog(i.id)">Delete</a>
                      </div>
                    </div>
                  </div>
                  <p class="body--title">
                    {{ formatText(i.title, 45) }}
                  </p>
                  <div class="body--details">
                    <div class="item">
                      <i class="fa fa-clock"></i>
                      <span>{{ convertDate(i.created) }}</span>
                    </div>
                    <div class="item">
                      <i class="fa fa-user"></i>
                      <span>
                        {{ i.author }}
                      </span>
                    </div>
                    <div class="item" (click)="likeHandle(i?.id, i)" style="color: salmon !important"
                      *ngIf="isMarketplace">
                      <i class="fa-{{ hasChecked(i?.bottomBannerLikes) ? 'solid' : 'regular' }} fa-heart"></i>
                      <span>{{ i.bottomBannerLikes?.length }}</span>
                    </div>
                  </div>
                  <button class="button-2" [routerLink]="'/news/' + (i.slug ?? i.id)">Read More</button>
                </div>
              </div>
            </ng-container>
          </div>
          } @else if (category == 'SG News' || category == 'All') {
          <div class="sg-new-grid">
            @for (i of banners.data; track $index) {
            <div class="my-card">
              <div class="heart" (click)="likeHandle(i?.id, i)" style="color: salmon !important">
                <i class="fa-{{ hasChecked(i?.bottomBannerLikes) ? 'solid' : 'regular' }} fa-heart"></i>
                <span>{{ i.bottomBannerLikes?.length }}</span>
              </div>
              <img loading="lazy" src="{{ imgUrl + i.image }}" [routerLink]="'/news/' + (i.slug ?? i.id)" alt="..."
                (error)="commonService.handleError($event)" />
              <div class="body">
                <div class="body--meta">
                  <span>{{ i.category }}</span>
                  <div class="options">
                    <div class="icon" *ngIf="isLogin" aria-hidden="true" id="list-new" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="fa fa-ellipsis-v"></i>
                    </div>
                    <div class="dropdown-menu" aria-labelledby="list-new">
                      <a class="dropdown-item" *ngIf="roleService.roles?.permissions['NEWS_ARTICLE']?.includes('ADD')"
                        (click)="openModalRelate(i)">Add Relate Article</a>
                      <a class="dropdown-item"
                        *ngIf="roleService.roles?.permissions['NEWS_ARTICLE']?.includes('REMOVE') && i?.related?.length > 0"
                        (click)="openModalRelate(i,true)">Remove Relate Article</a>
                      <a class="dropdown-item" (click)="addDiamonds(AddDiamonds, i)">Add Diamonds</a>
                      <a class="dropdown-item"
                        *ngIf="this.appUserId == i.createdBy || roleService?.roles?.users?.includes('MEMBER_NEWS')"
                        (click)="editBlog(i)">Edit</a>
                      <a class="dropdown-item"
                        *ngIf="this.appUserId == i.createdBy || roleService?.roles?.users?.includes('MEMBER_NEWS')"
                        (click)="deleteBlog(i.id)">Delete</a>
                    </div>
                  </div>
                </div>
                <p class="body--title" [routerLink]="'/news/' + (i.slug ?? i.id)">
                  {{ i.title }}
                </p>
                <div class="body--details">
                  <div class="item">
                    <i class="fa fa-user"></i>
                    <span>
                      {{ i.author | truncate : 20 }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
          } @else {
          <div class="grid-mobile">
            <ng-container *ngFor="let i of banners.data; let index = index">
              <div class="my-card" [ngClass]="{ order: index % 2 }">
                <img loading="lazy" src="{{ imgUrl + i.image }}" [routerLink]="'/news/' + (i.slug ?? i.id)" alt="..."
                  (error)="commonService.handleError($event)" />
                <div class="heart" (click)="likeHandle(i?.id, i)" style="color: salmon !important">
                  <i class="fa-{{ hasChecked(i?.bottomBannerLikes) ? 'solid' : 'regular' }} fa-heart"></i>
                  <span>{{ i.bottomBannerLikes?.length }}</span>
                </div>
                <div class="body">
                  <div>
                    <div class="body--meta">
                      <span>{{ i.category }}</span>
                      <div class="options">
                        <div class="icon" aria-hidden="true" id="list-new" *ngIf="isLogin" data-toggle="dropdown"
                          aria-haspopup="true" aria-expanded="false">
                          <i class="fa fa-ellipsis-v"></i>
                        </div>
                        <div class="dropdown-menu" aria-labelledby="list-new">
                          <a *ngIf="roleService.roles?.permissions['NEWS_ARTICLE']?.includes('ADD')"
                            class="dropdown-item" (click)="openModalRelate(i)">Add Relate Article</a>
                          <a *ngIf="roleService.roles?.permissions['NEWS_ARTICLE']?.includes('REMOVE') && i?.related?.length > 0"
                            class="dropdown-item" (click)="openModalRelate(i,true)">Remove Relate
                            Article</a>
                          <a class="dropdown-item" (click)="addDiamonds(AddDiamonds, i)">Add Diamonds</a>
                          <a class="dropdown-item"
                            *ngIf="this.appUserId == i.createdBy || roleService?.roles?.users?.includes('MEMBER_NEWS')"
                            (click)="editBlog(i)">Edit</a>
                          <a class="dropdown-item"
                            *ngIf="this.appUserId == i.createdBy || roleService?.roles?.users?.includes('MEMBER_NEWS')"
                            (click)="deleteBlog(i.id)">Delete</a>
                        </div>
                      </div>
                    </div>
                    <p class="body--title" [routerLink]="'/news/' + (i.slug ?? i.id)">
                      {{ i.title }}
                    </p>
                    <div class="body--details">
                      <!-- <div class="item">
                          <i class="fa fa-clock"></i>
                          <span>{{ convertDate(i.created) }}</span>
                        </div> -->
                      <div class="item">
                        <i class="fa fa-user"></i>
                        <span>
                          {{ i.author }}
                        </span>
                      </div>
                      <!-- <div class="item" style="color: salmon !important">
                          <i class="fa-{{ hasChecked(i?.bottomBannerLikes) ? 'solid' : 'regular' }} fa-heart"></i>
                          <span>{{ i.bottomBannerLikes?.length }}</span>
                        </div> -->
                    </div>
                    <!-- <div class="body--desc" [innerHTML]="formatText(i.text, 60)"></div> -->
                    <button [routerLink]="'/news/' + (i.slug ?? i.id)" class="button-2">Read More</button>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          }

          <br />
          <div class="d-flex justify-content-end">
            <nav aria-label="..." class="mb-3" *ngIf="banners.lastPage > 1">
              <ul class="pagination">
                <li class="page-item" [class.disabled]="banners.currentPage === 1">
                  <button class="page-link" (click)="getNewsList()">First</button>
                </li>
                <ng-container *ngFor="let page of getPages()">
                  <li class="page-item" [class.active]="page === banners.currentPage">
                    <button class="page-link" (click)="getNewsList(page)">
                      {{ page }}
                    </button>
                  </li>
                </ng-container>
                <li class="page-item" [class.disabled]="banners.currentPage === banners.lastPage">
                  <button class="page-link" (click)="getNewsList(banners.lastPage)">Last</button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="tags">
          <div class="tags__header" [ngClass]="{ active: !openBulletin }" (click)="openBulletin = !openBulletin">
            <div><i class="fa-solid fa-newspaper"></i> Popular Bulletin</div>
            <i class="fas fa-chevron-down"></i>
          </div>
          <div class="tags__body" [ngClass]="{ active: !openBulletin }">
            <app-bulletin></app-bulletin>
          </div>
        </div>

        <div class="tags">
          <div class="tags__header" [ngClass]="{ active: !openTags }" (click)="openTags = !openTags">
            <div><i class="fa-solid fa-tags"></i> Popular Tags</div>
            <i class="fas fa-chevron-down"></i>
          </div>
          <div class="tags__body" [ngClass]="{ active: !openTags }">
            <ul>
              <li (click)="mainHashtagChange($event, row)" *ngFor="let row of hashtags"
                [style.backgroundColor]="activeMainHashtag == row ? 'rgb(105, 44, 189, 0.2)' : ''">
                <span>{{ row }}</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="tags">
          <div class="tags__header active">
            <div><i class="fa-solid fa-newspaper"></i> Latest News</div>
          </div>

          <div class="tags__news">
            <div *ngFor="let news of latestNews" class="news-card mb-3"
              [routerLink]="'/news/' + (news.slug ?? news.id)">
              <div class="news-card__image">
                <img loading="lazy" class="latest-news-img" [src]="imgUrl + news.image" alt="{{ news.title }}"
                  (error)="commonService.handleError($event)" />
              </div>
              <div class="news-card__content">
                <h3 class="news-card__title d-md-block d-none" style="height: 2.15rem; overflow: hidden;">{{
                  formatText(news.title) }}</h3>
                <h3 class="news-card__title d-md-none d-block">{{ shortText(formatText(news.title), 50) }}</h3>
                <p class="news-card__date">
                  <i class="fa-solid fa-calendar"></i> {{ convertDate(news.created) }}
                </p>
                <p class="news-card__date">
                  <i class="fa-solid fa-user"></i> {{ news.author }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="container">
    <h1 style="font-size: 28px;  text-align: center;" itemprop="headline">KACHIING NEWS</h1>
    <p style="font-size: 16px;  text-align: center;width:80%;margin:auto;" itemprop="description"><i>Stay updated with
        the latest consumer news, trends, and buying guides in Singapore. Kachiing News covers top products, services,
        reviews, and smart shopping tips to help you make informed decisions.
      </i></p>

    <div class="news-intro">
      <h2>Welcome to Kachiing News</h2>
      <p>
        Your trusted source for smart consumer advice in Singapore. Discover honest reviews, trending services, and
        expert buying tips—all in one place.
      </p>
      <p>
        From tech gadgets and car care to home services and lifestyle hacks, Kachiing News curates the latest insights
        to help you make informed choices. Whether you’re searching for the best baby carriers, reliable laptop repairs,
        or affordable beauty treatments, we’ve got you covered.
      </p>
      <p>
        Stay tuned for regular updates and practical shopping advice tailored for Singaporeans. Bookmark us and shop
        smarter with Kachiing!
      </p>
    </div>
  </div>
</div>
<div class="newsletter">
  <div class="container">
    <div class="mb-4">
      <div class="newsletter__title">Join our newsletter</div>
      <div>Get the latest updates and news from Kachiing</div>
    </div>
    <div class="mb-4">
      <!-- <ul class="social">
      <li>
        <a
          href="https://www.facebook.com/kachiingcommunity/about_details"
          target="_blank"
        >
          <i class="fa-brands fa-facebook-f"></i>
        </a>
      </li>
      <li>
        <a
          href="https://medium.com/@kachiing/terms-of-service-kachiing-b9bc9739c9ed"
          target="_blank"
        >
          <i class="fa-brands fa-medium"></i>
        </a>
      </li>
    </ul> -->
      <div class="my-form">
        <!-- <input type="text" placeholder="Enter your email" /> -->
        <button class="button-2">Subscribe</button>
      </div>
      <div class="text">
        By subscribing you agree to with our
        <a routerLink="/privacy">Privacy Policy</a>
      </div>
    </div>
  </div>
</div>
<app-form-new #formNew (initData)="getNewsList()"></app-form-new>

<ng-template #AddDiamonds let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="title">Add Diamonds</h2>
    <div class="form-group">
      <label class="mb-0">Enter Diamonds</label>
      <input type="number" [(ngModel)]="diamond" class="form-control" />
    </div>
    <button (click)="submitAddDiamonds()" class="ml-auto d-flex my-button-3"><i class="fa-solid fa-save"></i>
      Add</button>
  </div>
</ng-template>